module.exports = __webpack_public_path__ + "img/449.fec7380a.jpg";